import * as Address from './address';

import { BaseItem, FindAll, NullablePartial } from './common';

export interface Pharmacy {
  id: string;
  name: string;
  phone: string | null;
  status: string | null;
  kind: string | null;
  ncpdpId: string | null;
}

export interface PrevisitPharmacy extends NullablePartial<Pharmacy> {
  address: Address.Address;
  staticMapUrl?: string;
}

export interface PharmacyWithAddress extends Pharmacy, Address.Address {}

export type FindAllOptions = FindAll<
  Pick<
    PharmacyWithAddress,
    'name' | 'phone' | 'status' | 'kind' | 'ncpdpId' | 'state'
  > & { q?: string },
  BaseItem
>;

export const PHARMACY_IMPORT_COLUMNS: (keyof PharmacyWithAddress)[] = [
  'name',
  'phone',
  'ncpdpId',
  'address',
  'unitNumber',
  'city',
  'state',
  'zip',
  'longitude',
  'latitude',
  'status',
  'kind',
];

export enum Kind {
  Pharmacy = 'PHARMACY',
  DialysisCenter = 'DIALYSIS_CENTER',
}
